import {
  MoreInfoWrapper,
  SummaryBox,
  SummaryBoxButton,
  SummaryBoxInfo,
  SummaryBoxItemTitle,
  SummaryBoxMore,
  SummaryBoxWrapper,
} from "../../style";
import { useEffect, useMemo, useState } from "react";
import {
  SettlementResponse,
  SettlementExpenseDto,
} from "../../../../api/settlement";
import MoreInfo, {
  DialogPayType,
} from "../../../timer-controller/components/sit-in/components/more";

interface SolutionHeaderProps {
  data: SettlementResponse | undefined;
  handleExpenditurePopup: () => void;
  settlementExpenseList: SettlementExpenseDto[];
  expenditure: number;
}

export interface FinancialType {
  name: string;
  icon: string;
  value: number;
  type: DialogPayType[];
  name2?: string;
  value2?: number;
}
export const SolutionHeader = ({
  data,
  handleExpenditurePopup,
  settlementExpenseList,
  expenditure,
}: SolutionHeaderProps) => {
  const [point, setPoint] = useState(0);
  const [usePoint, setUsePoint] = useState(0);
  const [income, setIncome] = useState(0);
  const [isHover, setIsHover] = useState<string>("");
  const [incomeCash, setIncomeCash] = useState(0);
  const [incomeCard, setIncomeCard] = useState(0);
  const [incomeBank, setIncomeBank] = useState(0);

  useEffect(() => {
    if (!data) return;
    let usePoint = 0;
    let givePoint = 0;
    data.tournaments.forEach((item) => {
      usePoint += item.usedPoint;
      item.distributionDetails.forEach((data) => {
        givePoint += data.resultPoints;
      });
    });

    setUsePoint(usePoint);
    const result = givePoint + data.transactionPoint;
    setPoint(result);
    setIncomeCash(data.income.cash);
    setIncomeCard(data.income.card);
    setIncomeBank(data.income.bankTransfer);
    const sum = data.income.cash + data.income.card + data.income.bankTransfer;
    setIncome(sum);
  }, [data]);

  const expenseList: DialogPayType[] = useMemo(
    () =>
      settlementExpenseList.map((item) => {
        return {
          name: item.description,
          value: item.amount,
          unit: "원",
        };
      }),
    [settlementExpenseList],
  );

  const IncomePayType: DialogPayType[] = [
    {
      name: "현금",
      value: incomeCash,
      unit: "원",
    },
    {
      name: "카드",
      value: incomeCard,
      unit: "원",
    },
    {
      name: "계좌",
      value: incomeBank,
      unit: "원",
    },
  ];

  const financial = useMemo(
    () => [
      {
        name: "매출",
        icon: "income",
        value: income,
        type: IncomePayType,
      },
      {
        name: "지출",
        icon: "expenditure",
        value: expenditure,
        type: expenseList,
      },
    ],
    [income, expenditure, point, usePoint, IncomePayType],
  );

  return (
    <SummaryBoxWrapper>
      {financial.map((item, index) => (
        <SummaryBox>
          <div className="icon">
            <img src={`/image-web/solution/${item.icon}.png`} alt={item.name} />
          </div>
          <SummaryBoxInfo>
            <SummaryBoxItemTitle>
              {item.name}
              <SummaryBoxMore
                onMouseOver={() => setIsHover(item.name)}
                onMouseOut={() => setIsHover("")}
              >
                <img src="/image-web/solution/more.png" alt="자세히 보기" />
              </SummaryBoxMore>
              {index === 1 && (
                <SummaryBoxButton
                  $disabled={false}
                  onClick={handleExpenditurePopup}
                >
                  지출 입력
                </SummaryBoxButton>
              )}
              {isHover === item.name && (
                <MoreInfoWrapper>
                  <MoreInfo name={item.name} dialogPayType={item.type} />
                </MoreInfoWrapper>
              )}
            </SummaryBoxItemTitle>
            <div className={`value i${index}`}>
              {item.value.toLocaleString()} <span>원</span>
            </div>
          </SummaryBoxInfo>
        </SummaryBox>
      ))}
    </SummaryBoxWrapper>
  );
};
